import React from "react"
import { Box, Grid } from "@mui/material"

const CustomOrderLogoSelect = ({
  selectedLogoOption,
  setSelectedLogoOption,
  logoOptions,
  updateOptions,
  orderData,
  isStaff,
}) => {
  let border = null
  let boxShadow = "1px 1px 10px rgba(0, 0, 0, 0.5)"
  let disabled = orderData?.locked && !isStaff
  return (
    <Box pt={3}>
      <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 2 }}>
        {logoOptions.map((logoOption, i) => {
          const selected = selectedLogoOption?.id === logoOption?.id
          return (
            <Box
              key={i}
              onClick={() => {
                if (!disabled) {
                  updateOptions([logoOption])
                }
              }}
              sx={{
                width: 100,
                height: 100,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 1.5,
                cursor: disabled ? "not-allowed" : "pointer",
                transition: "all 0.15s",
                border: selected ? "1.5px solid #c8b99a" : "1.5px solid transparent",
                bgcolor: selected ? "rgba(200,185,154,0.1)" : "rgba(255,255,255,0.04)",
                opacity: disabled ? 0.5 : 1,
                "&:hover": disabled ? {} : {
                  border: "1.5px solid rgba(255,255,255,0.2)",
                },
              }}
            >
              <img
                src={logoOption?.extra_data?.url}
                alt={logoOption.value}
                style={{
                  maxWidth: 80,
                  maxHeight: 80,
                  objectFit: "contain",
                }}
              />
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}

export default CustomOrderLogoSelect
